import { SEVERITY } from "helpers/utils.js";
import {
  GET_DELIVERER,
  GET_DELIVERER_SUCCESS,
  GET_DELIVERER_FAIL,
  GET_DELIVERER_BY_ID_SUCCESS,
  ADD_NEW_DELIVERER,
  ADD_NEW_DELIVERER_SUCCESS,
  UPDATE_DELIVERER,
  UPDATE_DELIVERER_SUCCESS,
  DELETE_DELIVERER,
  DELETE_DELIVERER_SUCCESS,
  DELIVERER_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const deliverer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_DELIVERER:
    case UPDATE_DELIVERER:
    case DELETE_DELIVERER:
    case GET_DELIVERER:
      return {
        ...state,
        loading: true,
      };
    case GET_DELIVERER_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_DELIVERER_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case ADD_NEW_DELIVERER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Deliverer",
          text: "Deliverer has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_DELIVERER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Deliverer",
          text: "Deliverer has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_DELIVERER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Deliverer",
          text: "Deliverer has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_DELIVERER_FAIL:
      return {
        ...state,
        error: payload,
      };
    case DELIVERER_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default deliverer;
